import formatMoney from "./utils/format-money";
import Product from "./product";
import Minicart from "./minicart.js";

import {
	Swiper,
	Navigation,
	Pagination,
	Scrollbar,
	Autoplay,
} from "swiper/swiper.esm.js";
Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

// init Swiper:
const swiper = new Swiper();

const Cart = {
	init: function () {
		this.addItemToCart();
		this.initQuickView();
		this.initQty();
		this.initCloseQuickAdd();
		this.initChangeImage();
		this.cartCount();
		this.initPopupSizeGuide();
	},

	AjaxAddToCart: function (productItem) {
		productItem.find("[data-cart-text]").hide();
		productItem.find("[data-cart-load]").show();

		$.post("/cart/add.js", productItem.serialize(), null, "json")
			.done(function (data) {
				productItem.find("[data-cart-text]").show();
				productItem.find("[data-cart-load]").hide();
				Minicart.populateCartDrawer(true);
				$(".quick-add").hide();
			})
			.fail(function ({ responseJSON }) {
				const { description } = responseJSON;
				productItem.find("[data-cart-text]").show();
				productItem.find("[data-cart-load]").hide();
				productItem.find(".cart-error-message").html(description).fadeIn();
				setTimeout(() => {
					productItem.find(".cart-error-message").fadeOut();
				}, 3500);
			});
	},

	addItemToCart: function () {
		$("body").on("click", "[data-add-to-cart]", function (e) {
			e.preventDefault();
			const productItem = $(this).parents("form");
			var isOptions = $("[data-pdp-option]");
			if (isOptions.length) {
				$(".pdp-option-select").each(function () {
					var itemOption = $(this).val();
					if (itemOption == null) {
						$(this).addClass("option-error");
					} else {
						$(this).removeClass("option-error");
					}
				});
			} else {
				Cart.AjaxAddToCart(productItem);
			}

			if ($("#pdp-variant-id").val() != "") {
				Cart.AjaxAddToCart(productItem);
			}
			cartCount();
		});
	},

	initQuickView: () => {
		$("body").on("click", ".js-quick-add", function (e) {
			e.preventDefault();
			var handle = $(this).data("href");
			$.get(handle + "?view=quick-view", function (data) {
				$(".quick-add").show();
				$(".quick-add").html(data);
				Product.initialize(handle);
				Cart.initSliderImage();
			});
		});
	},

	initQty: () => {
		$("body").on("click", "[data-qty-plus]", function () {
			var quantity = $("[data-qty-input]").val(),
				number = parseFloat(quantity) + 1;

			$(this).prev("[data-qty-input]").val(number);
			cartCount();
		});

		$("body").on("click", "[data-qty-minus]", function () {
			var quantity = $("[data-qty-input]").val(),
				number = parseFloat(quantity) - 1;

			if (quantity >= 2) {
				$(this).next("[data-qty-input]").val(number);
			}
			cartCount();
		});
	},

	initCloseQuickAdd: () => {
		$("body").on("click", ".js-close-quick-add", function (e) {
			e.preventDefault();
			$(".quick-add").hide();
			$(".quick-add").empty();
		});
	},

	initSliderImage: () => {
		var imagesSwiper = new Swiper(".js-product-slider", {
			slidesPerView: 1,
			pagination: {
				el: ".swiper-pagination",
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
		});
	},

	initChangeImage: () => {
		$("body").on("click", ".js-swatch-item", function () {
			let UrlImage = $(this).data("image");
			let productItem = $(this).parents(".lookbook-product__item");
			productItem.find(".js-swatch-item").removeClass("active");
			$(this).addClass("active");
			productItem.find(".js-product-image").attr("src", UrlImage);
		});
	},

	cartCount: async () => {
		const cartIcon = document.querySelector("[data-cartcount]");
		if (!cartIcon) return;
		await fetch("/cart.js")
			.then((cartResponse) => cartResponse.json())
			.then((data) => {
				let itemCount = data.item_count;
				if (itemCount >= 1) {
					cartIcon.classList.remove("d-none");
				}
				cartIcon.innerHTML = data.item_count;
			});
	},

	initPopupSizeGuide: () => {
		$("body").on("click", ".js-size-guide", function () {
			$("body").addClass("open-size-guide");
		});

		$("body").on("click", ".js-close-guide", function () {
			$("body").removeClass("open-size-guide");
		});
	},
};

window.Cart = Cart;

$(function () {
	Cart.init();
});

export default Cart;
